import React, { ChangeEventHandler } from 'react';

import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';

type Props = {
  searchText: string;
  onSearch: (value: string) => void;
  onClearSearch: () => void;
  label?: string;
  placeholder?: string;
  tooltipTitle?: string;
};

const styles = makeStyles(theme => ({
  searchIcon: {
    color: '#F07037',
    fontSize: '22px',
    paddingLeft: '0',
  },
  root: {
    '& .MuiIconButton-root:hover': {
      backgroundColor: 'transparent',
    },
    '& .MuiOutlinedInput-input': {
      height: '40px',
      padding: '0 10px 0 0',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #E5EBF5',
    },
    '& .MuiIconButton-root': {
      paddingRight: '0',
    },
    '& .MuiInputBase-root': {
      borderRadius: '6px',
      backgroundColor: '#fff',
    },
  },
}));

export default function SearchInput({
  searchText,
  onSearch,
  onClearSearch,
  placeholder = 'Search...',
  label = '',
  tooltipTitle = '',
}: Props): JSX.Element {
  const classes = styles();
  const onChange: ChangeEventHandler<HTMLInputElement> = event =>
    onSearch(event.currentTarget.value);

  const inputProps = {
    startAdornment: (
      <InputAdornment position="start">
        <SearchIcon className={classes.searchIcon} />
      </InputAdornment>
    ),
    endAdornment: searchText && (
      <InputAdornment position="end">
        <IconButton onClick={onClearSearch} size="large">
          <ClearIcon />
        </IconButton>
      </InputAdornment>
    ),
  };

  return (
    <Tooltip title={tooltipTitle}>
      <TextField
        id="outlined-basic"
        variant="outlined"
        placeholder={placeholder}
        // type="search"
        value={searchText}
        label={label}
        onChange={onChange}
        InputProps={inputProps}
        className={classes.root}
        fullWidth
      />
    </Tooltip>
  );
}
